import React, { useCallback, useEffect, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { alpha } from '@mui/material/styles';

import styled, { css } from '../../styled';
import { colorsPalette } from '../../theme';
import useVerse from '../../utils/hooks/useVerse';
import { VideoPlayer } from '../VideoPlayer';

const VideoModal = ({ verseId, url = '', bumperUrl, duration, title, expertName, closeModal }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const { onVideoClose } = useVerse();

  const closeModalHandler = () => {
    onVideoClose();
    closeModal();
  };

  useEffect(() => {
    const escHandler = (e) => {
      if (e.key === 'Escape') {
        onVideoClose();
        closeModal();
      }
    };

    if (typeof document !== 'undefined') {
      document.body.addEventListener('keydown', escHandler, false);

      return () => document.body.removeEventListener('keydown', escHandler, false);
    }
  }, [onVideoClose, closeModal]);

  const onToggleFullscreen = useCallback((isFullscreen) => {
    setIsFullScreen(isFullscreen);
  }, []);

  return (
    <Container>
      <ModalContent optionalStyles={isFullScreen && generatedModalContent}>
        <CloseBtn className={'close-btn'} onClick={closeModalHandler}>
          <CloseIcon style={{ color: colorsPalette.white }} />
        </CloseBtn>
        <StyledVideoPlayer
          verseId={verseId}
          videoUrl={url}
          bumperVideoUrl={bumperUrl}
          isModal
          duration={duration}
          title={title}
          expertName={expertName}
          onToggleFullscreen={onToggleFullscreen}
          isFullScreen={isFullScreen}
        />
      </ModalContent>
    </Container>
  );
};

export default VideoModal;

const Container = styled('div')`
  position: relative;
  display: flex;
  align-items: center;
  width: 80vw;
  height: calc(70vh + 35px);
  padding-top: 35px;
`;
const ModalContent = styled('div', {
  shouldForwardProp: (prop) => prop !== 'optionalStyles',
})`
  border-radius: 5px;
  width: 100%;
  height: 100%;
  text-align: center;

  ${({ optionalStyles }) => optionalStyles}
`;
const generatedModalContent = css`
  top: 0;
  left: 0;
  transform: none;
  width: 100vw;
  height: 100vh;
`;
const CloseBtn = styled('div')`
  position: absolute;
  cursor: pointer;
  z-index: 20;
  padding: 3px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: ${alpha(colorsPalette.white, 0.33)};
  top: 0;
  right: 0;
`;
const StyledVideoPlayer = styled(VideoPlayer)`
  width: 100%;
  height: 100%;
`;
